<template>
  <wizard-panel name="standard" :status="panels.standard" @open="openPanel" @close="closePanel">
    <div class="wizard-panel__inner" v-if="panels.standard === 1">
      <div class="wizard-panel__column wizard-panel__column_main js-wizard-panel-column">
        <header class="panel-head">
          <div class="badge wizard-panel__badge" v-html="kindName"></div>

          <div v-if="!read" class="panel-head__inner justify-center" style="margin-bottom: 30px">
            <div class="panel-head__item">

              <button type="button" class="btn btn_primary" @click="elDialogs.standards = true">Создать или найти&nbsp;ПС</button>
            </div>
            <div class="panel-head__item" style="width: 100%;">
              <v-select class="select" placeholder="Жизненный цикл" label="name" v-model="tempLifecycleId"
                        :clearable="false" :options="lifecycles" :reduce="(item) => item.id"
                        @input="lifecycleIdChanged = true">
                <template #search="{attributes, events}">
                  <input
                      class="vs__search"
                      :required="!lifecycleId"
                      v-bind="attributes"
                      v-on="events"
                  />
                </template>
                <template #no-options="{ search, searching, loading }">
                  {{ SELECT_NOT_FOUND }}
                </template>
                <template #open-indicator="{ attributes }">
                                <span v-bind="attributes">
                                    <icon-base viewBox="0 0 14 8" class="select__arrow"><icon-arrow-down/></icon-base>
                                </span>
                </template>
              </v-select>
            </div>
          </div>
          <div class="panel-head__inner">
            <div class="panel-head__item">
              <h2>Профессиональный стандарт</h2>
            </div>

            <div class="panel-head__item">
              <el-tooltip :content="standard.status_id === 1 ? 'Утверждено' : 'Опубликовано в реестре'"
                          placement="bottom-end" popper-class="is-accept" v-if="standard.status_id === 1">
                <icon-base viewBox="0 0 20 20" class="panel-head__icon">
                  <icon-accept/>
                </icon-base>
              </el-tooltip>
            </div>
          </div>
        </header>

        <div class="wizard-panel__content">
          <ul class="data-list">
            <li class="data-list__item">
              <section class="info">
                <form @submit.prevent="updateStandard($event, 'mainInfoEditable')">
                  <header class="info__head">
                    <div class="info__head-inner">
                      <div class="info__head-item">
                        <p class="info__title">Общая информация</p>
                      </div>

                      <div class="info__head-item" v-if="!read && !mainInfoEditable">
                        <button type="button" class="change-btn" @click.prevent="mainInfoEditable = true">
                          Редактировать

                          <icon-base viewBox="0 0 18 18" class="change-btn__icon">
                            <icon-edit/>
                          </icon-base>
                        </button>
                      </div>
                      <div class="info__head-item" v-else-if="!read">
                        <button type="submit" :disabled="!nameForKind || isExistStandard ? !nameForStandard : false"
                                class="btn btn_success btn_small">
                          Сохранить

                          <icon-base width="16" height="16" viewBox="0 0 512 512" class="btn__icon">
                            <icon-save/>
                          </icon-base>
                        </button>

                        <button type="button" class="btn btn_danger btn_small" @click.stop.prevent="declineChanges">
                          Отменить

                          <icon-base width="14" height="14" viewBox="0 0 14 14" class="btn__icon">
                            <icon-cancel/>
                          </icon-base>
                        </button>
                      </div>
                    </div>
                  </header>

                  <div class="info__inner">
                    <aside class="info__aside">
                      <div class="info-cell">
                        <label class="label" for="kind-code">Код</label>

                        <div class="info-cell__field">
                          <masked-input mask="11.111" id="kind-code" name="kind_code" placeholder="Не заполнено"
                                        class="info-cell__input" :value="kindCode" :disabled="!mainInfoEditable"
                                        @input="codeChanged = true"/>
                        </div>
                      </div>

                      <div class="info-cell">
                        <label for="register-number" class="label">Регистрационный номер</label>

                        <div class="info-cell__field">
                          <input type="text" id="register-number" name="register_number" placeholder="Не заполнено"
                                 class="info-cell__input" v-model="registerNumberForStandart"
                                 :disabled="!mainInfoEditable" @keypress="onlyNumber($event)">
                        </div>
                      </div>
                    </aside>

                    <div class="info__content">
                      <ul class="info-list">
                        <li class="info-list__item" v-if="isExistStandard">
                          <label for="standard-name" class="label info-list__label">Наименование профессионального
                            стандарта <sup>*</sup></label>

                          <div class="info-list__field">
                            <textarea id="standard-name" name="name" class="info-list__textarea"
                                      :class="{ 'is-active': mainInfoEditable && isExistStandard, 'info-list__textarea_error': mainInfoEditable && isExistStandard && !nameForStandard }"
                                      placeholder="Не заполнено" v-autogrow v-model="nameForStandard"
                                      :disabled="!mainInfoEditable || !isExistStandard"></textarea>
                          </div>
                        </li>
                        <li class="info-list__item" v-if="isExistStandard">
                          <label for="standard-status" class="label info-list__label">Статус профессионального
                            стандарта</label>

                          <div class="info-list__field">
                            <textarea id="standard-status" name="status_document" class="info-list__textarea"
                                      :class="{ 'is-active': mainInfoEditable && isExistStandard }"
                                      placeholder="Не заполнено" v-autogrow v-model="statusForStandart"
                                      :disabled="!mainInfoEditable || !isExistStandard"></textarea>
                          </div>
                        </li>
                        <li class="info-list__item">
                          <label for="kind-name" class="label info-list__label">Наименование вида профессиональной
                            деятельности*</label>

                          <div class="info-list__field">
                            <textarea id="kind-name" name="kind_name" class="info-list__textarea"
                                      :class="{ 'is-active': mainInfoEditable, 'info-list__textarea_error': mainInfoEditable && !nameForKind }"
                                      placeholder="Не заполнено" v-autogrow v-model="nameForKind"
                                      :disabled="!mainInfoEditable" @input="nameForKindChanged = true"></textarea>
                          </div>
                        </li>
                        <li class="info-list__item">
                          <label for="kind-goal" class="label info-list__label">Основная цель вида профессиональной
                            деятельности</label>

                          <div class="info-list__field">
                                                        <textarea id="kind-goal"
                                                                  name="kind_goal"
                                                                  class="info-list__textarea"
                                                                  style="height: 100px; "
                                                                  :class="{ 'is-active': mainInfoEditable, 'info-list__textarea_error': mainInfoEditable && !nameForKind }"
                                                                  placeholder="Не заполнено"
                                                                  v-model="goalForKind"
                                                                  :disabled="!mainInfoEditable"
                                                                  @input="nameForKindChanged = true">
                                                        </textarea>
                          </div>
                        </li>
                      </ul>

                    </div>
                  </div>
                </form>
              </section>
            </li>
            <li class="data-list__item" v-if="isExistStandard && !allLoader">
              <section class="info">
                <header class="info__head">
                  <div class="info__head-inner">
                    <div class="info__head-item">
                      <p class="info__title">Группа занятий</p>
                    </div>

                    <div v-if="!read && !okzsLoader" class="info__head-item">
                      <button type="button" class="change-btn" @click.prevent="elDialogs.okz = true">
                        Редактировать

                        <icon-base viewBox="0 0 18 18" class="change-btn__icon">
                          <icon-edit/>
                        </icon-base>
                      </button>
                    </div>
                  </div>
                </header>

                <local-preloader class="mt-24" v-if="okzsLoader"/>

                <div v-else class="info__inner mt-8">
                  <div class="info__content">
                    <el-table
                        cell-class-name="table__cell"
                        class="table table_second table_in-panel"
                        header-cell-class-name="table__title"
                        max-height="400"
                        :data="standard.okzs"
                    >
                      <el-table-column
                          label="Код ОКЗ"
                          prop="code"
                          sortable
                          :width="150"
                      >
                        <template slot-scope="scope">
                          <span v-html="GET_OKZS_BY_ID(scope.row).code"></span>
                        </template>
                      </el-table-column>
                      <el-table-column
                          label="Наименование"
                          prop="name"
                          sortable
                          :min-width="150"
                      >
                        <template slot-scope="scope">
                          <span v-html="GET_OKZS_BY_ID(scope.row).name"></span>
                        </template>
                      </el-table-column>
                      <el-table-column
                          v-if="!read"
                          width="48"
                      >
                        <template slot-scope="scope">
                          <selector-btn :options="accordionTableOkzOptionsForBtn" :toRight="true"
                                        :params="{ id: GET_OKZS_BY_ID(scope.row).id }" portal="selectorModal"
                                        @clickOnItem="callback"></selector-btn>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </section>
            </li>
            <li class="data-list__item" v-if="isExistStandard && !allLoader">
              <section class="info">
                <header class="info__head">
                  <div class="info__head-inner">
                    <div class="info__head-item">
                      <p class="info__title">Отнесение к&nbsp;видам экономической деятельности</p>
                    </div>

                    <div v-if="!read && !okvedsLoader" class="info__head-item">
                      <button type="button" class="change-btn" @click.prevent="elDialogs.okveds = true">
                        Редактировать

                        <icon-base viewBox="0 0 18 18" class="change-btn__icon">
                          <icon-edit/>
                        </icon-base>
                      </button>
                    </div>
                  </div>
                </header>

                <local-preloader class="mt-24" v-if="okvedsLoader"/>

                <div v-else class="info__inner mt-8">
                  <div class="info__content">
                    <el-table
                        class="table table_second table_in-panel"
                        cell-class-name="table__cell"
                        header-cell-class-name="table__title"
                        max-height="400"
                        :data="standard.okveds"
                    >
                      <el-table-column
                          label="Код ОКВЭД"
                          prop="code"
                          sortable
                          :width="150"
                      >
                        <template slot-scope="scope">
                          <span v-html="GET_OKVEDS_BY_ID(scope.row).code"></span>
                        </template>
                      </el-table-column>
                      <el-table-column
                          label="Наименование"
                          prop="name"
                          sortable
                          :min-width="150"
                      >
                        <template slot-scope="scope">
                          <span v-html="GET_OKVEDS_BY_ID(scope.row).name"></span>
                        </template>
                      </el-table-column>
                      <el-table-column
                          v-if="!read"
                          width="48"
                      >
                        <template slot-scope="scope">
                          <selector-btn :options="accordionTableOkvedOptionsForBtn" :toRight="true"
                                        :params="{ id: GET_OKVEDS_BY_ID(scope.row).id }" portal="selectorModal"
                                        @clickOnItem="callback"></selector-btn>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </section>
            </li>
            <li class="data-list__item" v-if="isExistStandard && !allLoader">
              <section class="info">
                <header class="info__head">
                  <div class="info__head-inner">
                    <div class="info__head-item">
                      <p class="info__title">Описание трудовых функций, входящих в&nbsp;профессиональный стандарт
                        (функциональная карта вида профессиональной деятельности)</p>
                    </div>

                    <div v-if="!read && !workFunctionsByStandardLoader" class="info__head-item">
                      <button type="button" class="change-btn" @click.prevent.stop="openItemsPanel">
                        Редактировать
                        <icon-base viewBox="0 0 18 18" class="change-btn__icon">
                          <icon-edit/>
                        </icon-base>
                      </button>
                    </div>
                    <div class="info__head-item">
                      <button v-if="read && !workFunctionsByStandardLoader && workFunctionsByStandard.length"
                              type="button" class="change-btn" @click.prevent.stop="openItemsPanel">
                        Просмотреть
                      </button>
                    </div>
                  </div>
                </header>
              </section>

              <local-preloader class="mt-24" v-if="workFunctionsByStandardLoader"/>

              <template v-else>
                <div v-if="!workFunctionsByStandard.length">
                  <div class="info-list__field mt-24">
                    <p class="info-list__textarea">Взаимосвязи отсутствуют</p>
                  </div>
                </div>

                <accordion class="accordion accordion_second" v-else>
                  <template slot="accordion-captions">
                    <div class="accordion__captions">
                      <div class="accordion-data-list">
                        <div class="accordion-data-list__item">
                          <div class="accordion-data-list__column text-center">
                            <span class="label">Код</span>
                          </div>
                          <div class="accordion-data-list__column">
                            <span class="label">Наименование</span>
                          </div>
                          <div class="accordion-data-list__column text-center">
                            <span class="label">Уровень</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>

                  <accordion-item v-for="workFunction in workFunctionsByStandard">
                    <template slot="accordion-head">
                      <div class="accordion__trigger">
                        <div class="accordion-data-list">
                          <div class="accordion-data-list__item">
                            <div class="accordion-data-list__column text-center" v-html="workFunction.code"></div>
                            <div class="accordion-data-list__column" v-html="workFunction.name"></div>
                            <div class="accordion-data-list__column text-center" v-html="workFunction.level"></div>
                          </div>
                        </div>

                        <button type="button" class="accordion__toggler">
                          <icon-base viewBox="0 0 14 8">
                            <icon-arrow-down/>
                          </icon-base>
                        </button>
                      </div>
                    </template>

                    <div class="accordion__data">
                      <div class="accordion-data-list">
                        <div class="accordion-data-list__item" v-for="item in workFunction.work_functions">
                          <div class="accordion-data-list__column text-center"
                               v-html="`${ workFunction.code }/${ item.subcode }`">
                          </div>
                          <div class="accordion-data-list__column" v-html="item.name"></div>
                          <div class="accordion-data-list__column text-center" v-html="item.level"></div>
                        </div>
                      </div>
                    </div>
                  </accordion-item>
                </accordion>
              </template>
            </li>
            <li class="data-list__item" v-if="isExistStandard && !allLoader">
              <section class="info">
                <form @submit.prevent="updateStandard($event, 'companyEditable')">
                  <header class="info__head">
                    <div class="info__head-inner">
                      <div class="info__head-item">
                        <p class="info__title">Сведения об&nbsp;организациях&nbsp;&mdash; разработчиках
                          профессионального стандарта</p>
                      </div>

                      <div class="info__head-item" v-if="!read && !companyEditable">
                        <button type="button" class="change-btn" @click.prevent="companyEditable = true">
                          Редактировать

                          <icon-base viewBox="0 0 18 18" class="change-btn__icon">
                            <icon-edit/>
                          </icon-base>
                        </button>
                      </div>
                      <div class="info__head-item" v-else-if="!read">
                        <button type="submit" class="btn btn_success btn_small">
                          Сохранить

                          <icon-base width="16" height="16" viewBox="0 0 512 512" class="btn__icon">
                            <icon-save/>
                          </icon-base>
                        </button>

                        <button type="button" class="btn btn_danger btn_small"
                                @click.stop.prevent="companyEditable = false;">
                          Отменить

                          <icon-base width="14" height="14" viewBox="0 0 14 14" class="btn__icon">
                            <icon-cancel/>
                          </icon-base>
                        </button>
                      </div>
                    </div>
                  </header>

                  <div class="info__inner">
                    <div class="info__content">
                      <ul class="info-list">
                        <li class="info-list__item">
                          <label for="company-developer" class="label info-list__label">Ответственная
                            организация-разработчик:</label>

                          <div class="info-list__field">
                            <textarea id="company-developer" name="responsible" class="info-list__textarea"
                                      :class="{ 'is-active': companyEditable }" placeholder="Не заполнено" v-autogrow
                                      :readonly="!companyEditable" v-model="responsible"></textarea>
                          </div>
                        </li>
                        <li class="info-list__item">
                          <label for="name-company-developer" class="label info-list__label">Наименования
                            организаций-разработчиков:</label>

                          <div class="info-list__field">
                            <textarea id="name-company-developer" name="organisations" class="info-list__textarea"
                                      :class="{ 'is-active': companyEditable }" placeholder="Не заполнено" v-autogrow
                                      :readonly="!companyEditable" v-model="organisations"></textarea>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </form>
              </section>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="wizard-panel__inner" v-else-if="standard && panels.standard === 2">
      <div class="wizard-panel__column js-wizard-panel-column">
        <div class="badge wizard-panel__badge" v-html="kindName"></div>

        <h2>Описание трудовых функций, входящих в&nbsp;профессиональный стандарт (функциональная карта вида
          профессиональной деятельности)</h2>

        <button v-if="!read" type="button" class="btn btn_action-second btn_full btn_transparent mb-12"
                @click.prevent="addGeneralWorkFunction">
          Добавить общую трудовую функцию
          <icon-base width="12" height="12" viewBox="0 0 12 12" class="btn__icon">
            <icon-action/>
          </icon-base>
        </button>

        <button v-if="!read" type="button" class="btn btn_action-second btn_full btn_transparent mb-24 ml-0"
                @click.prevent="addNewGeneralWorkFunction">
          Создать новую общую трудовую функцию

          <icon-base width="12" height="12" viewBox="0 0 12 12" class="btn__icon">
            <icon-action/>
          </icon-base>
        </button>

        <accordion class="accordion accordion_second">
          <template slot="accordion-captions">
            <div class="accordion__captions">
              <div class="accordion-data-list">
                <div class="accordion-data-list__item">
                  <div class="accordion-data-list__column text-center">
                    <span class="label">Код</span>
                  </div>
                  <div class="accordion-data-list__column">
                    <span class="label">Наименование</span>
                  </div>
                  <div class="accordion-data-list__column text-center">
                    <span class="label">Уровень</span>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <accordion-item v-for="(workFunction, index) in workFunctionsByStandard" :active="index === 0">
            <template slot="accordion-head">
              <div class="accordion__trigger">
                <div class="accordion-data-list">
                  <div class="accordion-data-list__item">
                    <div class="accordion-data-list__column text-center" v-html="workFunction.code"></div>
                    <div class="accordion-data-list__column" v-html="workFunction.name"></div>
                    <div class="accordion-data-list__column text-center" v-html="workFunction.level"></div>
                  </div>
                </div>

                <selector-btn v-if="!read" class="accordion-data-list__item_no-width"
                              :options="accordionGeneralWorkFunctionsOptionsForBtn" :toRight="true" :clickStop="true"
                              :params="{ id: workFunction.id, workFunction: workFunction }"
                              @clickOnItem="callback"></selector-btn>

                <button type="button" class="accordion__toggler">
                  <icon-base viewBox="0 0 14 8">
                    <icon-arrow-down/>
                  </icon-base>
                </button>
              </div>
            </template>

            <div class="accordion__data" v-if="workFunction.work_functions && workFunction.work_functions.length">
              <div class="accordion-data-list accordion-data-list_editable">
                <div
                    :class="{ 'accordion-data-list__item': true, 'is-active': item === activeWorkFunction || (!activeWorkFunction && index === 0 && count === 0 && getWorkFunctionItems(item)) }"
                    v-for="(item, count) in workFunction.work_functions" @click="getWorkFunctionItems(item)">
                  <div class="accordion-data-list__column text-center"
                       v-html="`${ workFunction.code }/${ item.subcode }`">
                  </div>
                  <div class="accordion-data-list__column" v-html="item.name">
                  </div>
                  <div class="accordion-data-list__column text-center">
                    <selector-btn v-if="!read" class="ml-auto" :options="accordionWorkFunctionOptionsForBtn"
                                  portal="selectorModal" :toRight="true" :clickStop="true"
                                  :params="{ commonWorkFunctionsId: workFunction.id, commonWorkFunctionsLevel: workFunction.level, id: item.id, workFunction: item }"
                                  @clickOnItem="callback"></selector-btn>
                  </div>
                </div>
              </div>
            </div>
          </accordion-item>
        </accordion>
      </div>
      <div class="wizard-panel__column wizard-panel__column_main js-wizard-panel-column">
        <div v-if="activeWorkFunction">
          <header class="panel-head">
            <div class="panel-head__inner">
              <div class="panel-head__item">
                <h2 v-html="activeWorkFunction.name"></h2>

                <p class="panel-head__text">Компетенции были добавлены автоматически, на&nbsp;основе выбранной
                  квалификации. <br/> Вы&nbsp;можете добавлять, создавать и&nbsp;удалять компетенции.</p>
              </div>
            </div>
          </header>

          <Tabs :key="activeWorkFunction.id">
            <Tab title="Трудовые действия">
              <button v-if="!read" type="button" class="btn btn_action-second btn_full mb-24"
                      @click.prevent="elDialogs.workActions = true">
                Добавить трудовые действия

                <icon-base width="12" height="12" viewBox="0 0 12 12" class="btn__icon">
                  <icon-action/>
                </icon-base>
              </button>

              <ul class="actions-list">
                <li style="text-align: center; color: #e2e2e2;" v-if="workFunctionItems.actions.length === 0">
                  Нет трудовых действий для отображения
                </li>
                <li class="actions-list__item" v-for="action in workFunctionItems.actions">
                  <div class="action">
                    <span v-html="action.name"></span>

                    <selector-btn v-if="!read" class="ml-16" :options="accordionActionOptionsForBtn"
                                  :params="{ id: action.id, item: action }" @clickOnItem="callback"></selector-btn>
                  </div>
                </li>
              </ul>
            </Tab>

            <Tab title="Знания">
              <button v-if="!read" type="button" class="btn btn_action-second btn_full mb-24"
                      @click.prevent="elDialogs.workKnowledge = true">
                Добавить знания

                <icon-base width="12" height="12" viewBox="0 0 12 12" class="btn__icon">
                  <icon-action/>
                </icon-base>
              </button>

              <ul class="actions-list">
                <li style="text-align: center; color: #e2e2e2;" v-if="workFunctionItems.knowledge.length === 0">
                  Нет знаний для отображения
                </li>
                <li class="actions-list__item" v-for="knowledge in workFunctionItems.knowledge">
                  <div class="action">
                    <span v-html="knowledge.name"></span>

                    <selector-btn v-if="!read" class="ml-16" :options="accordionWorkKnowledgeOptionsForBtn"
                                  :params="{ id: knowledge.id, item: knowledge }"
                                  @clickOnItem="callback"></selector-btn>
                  </div>
                </li>
              </ul>
            </Tab>

            <Tab title="Умения">
              <button v-if="!read" type="button" class="btn btn_action-second btn_full mb-24"
                      @click.prevent="elDialogs.workSkills = true">
                Добавить умения

                <icon-base width="12" height="12" viewBox="0 0 12 12" class="btn__icon">
                  <icon-action/>
                </icon-base>
              </button>

              <ul class="actions-list">
                <li style="text-align: center; color: #e2e2e2;" v-if="workFunctionItems.skills.length === 0">
                  Нет умений для отображения
                </li>
                <li class="actions-list__item" v-for="skill in workFunctionItems.skills">
                  <div class="action">
                    <span v-html="skill.name"></span>

                    <selector-btn v-if="!read" class="ml-16" :options="accordionWorkSkillOptionsForBtn"
                                  :params="{ id: skill.id, item: skill }" @clickOnItem="callback"></selector-btn>
                  </div>
                </li>
              </ul>
            </Tab>
          </Tabs>
        </div>
      </div>
    </div>

    <!-- DIALOGS -->
    <okveds-dialog/>
    <okz-dialog/>
    <standard-dialog :kindId="kindId" :standardId="standard && standard.id" @startLoad="allLoader = true"
                     @finishLoad="allLoader = false"/>
    <work-actions-dialog :standart="true" :workFunctionId="activeWorkFunction.id" v-if="activeWorkFunction"/>
    <work-knowledge-dialog :standart="true" :workFunctionId="activeWorkFunction.id" v-if="activeWorkFunction"/>
    <work-skills-dialog :standart="true" :workFunctionId="activeWorkFunction.id" v-if="activeWorkFunction"/>
    <new-general-work-functions-dialog :activeGeneralWorkFunction="activeGeneralWorkFunction"/>
    <general-work-functions-dialog/>
    <work-function-rename :is-standard="true" :activeWorkFunction="activeWorkFunctionForRename"/>
    <work-functions-item-rename :activeWorkFunctionItem="activeWorkFunctionItem"
                                @updateItems="updateWorkFunctionItems"/>
    <!-- /DIALOGS -->
  </wizard-panel>
</template>

<script>
import Vue from 'vue';
import MaskedInput from 'vue-masked-input';
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';

import panel from '@/mixins/panel';

import Accordion from '@/components/Accordion/Accordion';
import AccordionItem from '@/components/Accordion/AccordionItem';
import OkvedsDialog from '@/components/Dialogs/OkvedsDialog';
import OkzDialog from '@/components/Dialogs/OkzDialog';
import StandardDialog from '@/components/Dialogs/StandardDialog';
import Tab from '@/components/Tabs/Tab';
import Tabs from '@/components/Tabs/Tabs';
import WizardPanel from '@/components/WizardPanels/WizardPanel';
import WorkActionsDialog from '@/components/Dialogs/WorkActionsDialog';
import WorkKnowledgeDialog from '@/components/Dialogs/WorkKnowledgeDialog';
import WorkSkillsDialog from '@/components/Dialogs/WorkSkillsDialog';
import NewGeneralWorkFunctionsDialog from '@/components/Dialogs/NewGeneralWorkFunctionsDialog';
import GeneralWorkFunctionsDialog from '@/components/Dialogs/GeneralWorkFunctionsDialog';
import SelectorBtn from '@/components/SelectorBtn';
import LocalPreloader from '@/components/LocalPreloader'
import WorkFunctionRename from '@/components/Dialogs/WorkFunctionRename';
import WorkFunctionsItemRename from '@/components/Dialogs/WorkFunctionsItemRename';

const initialData = () => {
  return {
    activeWorkFunction: null,
    activeGeneralWorkFunction: null,
    activeWorkFunctionForRename: {},
    activeWorkFunctionItem: {},
    allLoader: false,

    companyEditable: false,
    funcDescriptionEditable: false,
    mainInfoEditable: false,
    codeChanged: false,
    lifecycleIdChanged: false,
    nameForKindChanged: false,
    nameForStandard: '',
    registerNumberForStandart: '',
    statusForStandart: '',
    goalForKind: '',
    nameForKind: '',

    tempLifecycleId: 0,

    accordionTableOkzOptionsForBtn: [
      {
        name: 'Удалить',
        warning: true,
        callback: 'deleteOkzItem'
      }
    ],
    accordionTableOkvedOptionsForBtn: [
      {
        name: 'Удалить',
        warning: true,
        callback: 'deleteOkvedItem'
      }
    ],
    accordionGeneralWorkFunctionsOptionsForBtn: [
      {
        name: 'Редактировать',
        callback: 'editGeneralWorkFunctionItem'
      },
      {
        name: 'Удалить',
        warning: true,
        callback: 'deleteGeneralWorkFunctionItem'
      }
    ],
    accordionWorkFunctionOptionsForBtn: [
      {
        name: 'Редактировать',
        callback: 'editWorkFunctionItem'
      },
      {
        name: 'Удалить',
        warning: true,
        callback: 'deleteWorkFunctionItem'
      }
    ],
    accordionActionOptionsForBtn: [
      {
        name: 'Редактировать',
        callback: 'editWorkActionItem'
      },
      {
        name: 'Удалить',
        warning: true,
        callback: 'deleteWorkActionItem'
      },
    ],
    accordionWorkKnowledgeOptionsForBtn: [
      {
        name: 'Редактировать',
        callback: 'editWorkKnowledgeItem'
      },
      {
        name: 'Удалить',
        warning: true,
        callback: 'deleteWorkKnowledgeItem'
      }
    ],
    accordionWorkSkillOptionsForBtn: [
      {
        name: 'Редактировать',
        callback: 'editWorkSkillItem'
      },
      {
        name: 'Удалить',
        warning: true,
        callback: 'deleteWorkSkillItem'
      }
    ]
  }
}

export default {
  mixins: [panel],
  props: {
    kindGoal: {
      type: String,
    },
    kindId: {
      type: Number,
      required: true
    },
    lifecycleId: {
      type: Number,
      required: false
    },
    okzsLoader: {
      type: Boolean,
      default: false
    },
    okvedsLoader: {
      type: Boolean,
      default: false
    },
    workFunctionsByStandardLoader: {
      type: Boolean,
      default: false
    },
    read: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Accordion,
    AccordionItem,
    MaskedInput,
    OkvedsDialog,
    OkzDialog,
    StandardDialog,
    Tab,
    Tabs,
    WizardPanel,
    WorkActionsDialog,
    WorkKnowledgeDialog,
    WorkSkillsDialog,
    NewGeneralWorkFunctionsDialog,
    GeneralWorkFunctionsDialog,
    SelectorBtn,
    LocalPreloader,
    WorkFunctionRename,
    WorkFunctionsItemRename
  },
  data() {
    return initialData();
  },
  methods: {
    ...mapActions('editor', [
      'LOAD_KINDS',
      'LOAD_WORK_FUNCTIONS_BY_STANDARD',
      'CREATE_STANDARD',
      'UPDATE_STANDARD',
      'UPDATE_KIND',
      'UPDATE_WORK_FUNCTION_ITEMS',
      'UPDATE_WORK_FUNCTION_ITEMS_FOR_STANDARD',
      'DELETE_OKZS',
      'DELETE_OKVED',
      'DELETE_WORK_FUNCTIONS_BY_STANDARD',
      'DELETE_WORK_FUNCTION_IN_COMMON_WORK_FUNCTION',
      'LOAD_DICTIONARY_WORK_FUNCTION_ITEMS',
    ]),
    ...mapMutations('common', ['TOGGLE_PANEL']),
    ...mapMutations('editor', ['GROUP_KINDS', 'SET_STANDARD']),

    closePanel() {
      this.SET_STANDARD(null);

      Object.assign(this.$data, initialData());
    },
    callback(emitObj) {
      this[emitObj.callback](emitObj.args)
    },
    declineChanges() {
      this.mainInfoEditable = false
      this.nameForStandard = this.standard?.name
      this.registerNumberForStandart = this.standard?.register_number
      this.nameForKind = this.kindName
    },

    deleteOkzItem({id}) {
      const params = {
        standardId: this.standard.id,
        ids: [id]
      }

      this.DELETE_OKZS(params)
    },
    deleteOkvedItem({id}) {
      const params = {
        standardId: this.standard.id,
        ids: [id]
      }

      this.DELETE_OKVED(params)
    },
    deleteGeneralWorkFunctionItem({id}) {
      const params = {
        standardId: this.standard.id,
        id: [id]
      }
      this.DELETE_WORK_FUNCTIONS_BY_STANDARD(params)
    },
    async deleteWorkFunctionItem({commonWorkFunctionsId, id}) {
      const params = {
        commonWorkFunctionsId,
        ids: [id],
      }
      await this.DELETE_WORK_FUNCTION_IN_COMMON_WORK_FUNCTION(params)
      await this.LOAD_WORK_FUNCTIONS_BY_STANDARD(this.standard.id)
    },
    deleteWorkActionItem({id}) {
      const newWorkFunctionItems = JSON.parse(JSON.stringify(this.workFunctionItems))


      newWorkFunctionItems.actions = newWorkFunctionItems.actions.filter(el => el.id != id)

      newWorkFunctionItems.workFunctionId = this.activeWorkFunction.id
      newWorkFunctionItems.skills = newWorkFunctionItems.skills.map(el => el.id)
      newWorkFunctionItems.actions = newWorkFunctionItems.actions.map(el => el.id)
      newWorkFunctionItems.knowledge = newWorkFunctionItems.knowledge.map(el => el.id)

      this.UPDATE_WORK_FUNCTION_ITEMS_FOR_STANDARD(newWorkFunctionItems)
    },
    deleteWorkKnowledgeItem({id}) {
      const newWorkFunctionItems = JSON.parse(JSON.stringify(this.workFunctionItems))
      newWorkFunctionItems.knowledge = newWorkFunctionItems.knowledge.filter(el => el.id != id)

      newWorkFunctionItems.workFunctionId = this.activeWorkFunction.id
      newWorkFunctionItems.skills = newWorkFunctionItems.skills.map(el => el.id)
      newWorkFunctionItems.actions = newWorkFunctionItems.actions.map(el => el.id)
      newWorkFunctionItems.knowledge = newWorkFunctionItems.knowledge.map(el => el.id)

      this.UPDATE_WORK_FUNCTION_ITEMS_FOR_STANDARD(newWorkFunctionItems)
    },
    deleteWorkSkillItem({id}) {
      const newWorkFunctionItems = JSON.parse(JSON.stringify(this.workFunctionItems))
      newWorkFunctionItems.skills = newWorkFunctionItems.skills.filter(el => el.id != id)

      newWorkFunctionItems.workFunctionId = this.activeWorkFunction.id
      newWorkFunctionItems.skills = newWorkFunctionItems.skills.map(el => el.id)
      newWorkFunctionItems.actions = newWorkFunctionItems.actions.map(el => el.id)
      newWorkFunctionItems.knowledge = newWorkFunctionItems.knowledge.map(el => el.id)

      this.UPDATE_WORK_FUNCTION_ITEMS_FOR_STANDARD(newWorkFunctionItems)
    },

    editFuncDescriptionMode() {
      this.funcDescriptionEditable = true;
    },
    editGeneralWorkFunctionItem({workFunction}) {
      this.activeGeneralWorkFunction = JSON.parse(JSON.stringify(workFunction))
      this.elDialogs.newGeneralWorkFunctionsDialog = true
    },
    editWorkFunctionItem({workFunction, commonWorkFunctionsLevel, commonWorkFunctionsId}) {
      this.activeWorkFunctionForRename = Object.assign(workFunction, {
        common_function_id: commonWorkFunctionsId,
        level: commonWorkFunctionsLevel
      })
      this.elDialogs.workFunctionsRename = true
    },
    editWorkActionItem({item}) {
      this.activeWorkFunctionItem = JSON.parse(JSON.stringify(Object.assign(item, {
        work_function_id: this.activeWorkFunction.id,
        type: 'action'
      })))
      this.elDialogs.workFunctionsItemRename = true
    },
    editWorkKnowledgeItem({item}) {
      this.activeWorkFunctionItem = JSON.parse(JSON.stringify(Object.assign(item, {
        work_function_id: this.activeWorkFunction.id,
        type: 'knowledge'
      })))
      this.elDialogs.workFunctionsItemRename = true
    },
    editWorkSkillItem({item}) {
      this.activeWorkFunctionItem = JSON.parse(JSON.stringify(Object.assign(item, {
        work_function_id: this.activeWorkFunction.id,
        type: 'skill'
      })))
      this.elDialogs.workFunctionsItemRename = true
    },

    async getWorkFunctionItems(item) {
      await this.LOAD_DICTIONARY_WORK_FUNCTION_ITEMS(item.id)

      this.activeWorkFunction = item;
    },
    onlyNumber(e) {
      if ((e.keyCode > 31 && (e.keyCode < 48 || e.keyCode > 57))) {
        e.preventDefault();
      } else {
        return true;
      }
    },
    addNewGeneralWorkFunction() {
      this.elDialogs.newGeneralWorkFunctionsDialog = true
      this.activeGeneralWorkFunction = null
    },
    addGeneralWorkFunction() {
      this.elDialogs.generalWorkFunction = true
    },

    openItemsPanel() {
      if (this.workFunctionsByStandard[0] && this.workFunctionsByStandard[0].work_functions) this.getWorkFunctionItems(this.workFunctionsByStandard[0].work_functions[0])

      this.elPanels.standard = 2
    },
    openPanel() {
      if (!this.standard?.id) {
        this.SET_STANDARD({
          approve_date: null,
          id: null,
          kind_code: null,
          kind_goal: this.kindGoal,
          kind_id: this.kindId,
          name: null,
          okveds: [],
          okzs: [],
          order_number: null,
          organisations: null,
          responsible: null,
          register_number: null,
          status_document: null,
          status_id: 1,
          work_functions: []
        });
      }

      this.nameForKind = this.kindName
    },

    async updateStandard(e, editable) {
      // Собираем новые значения и отправляем
      const formData = new FormData(e.target);

      const params = {};

      for (const pair of formData.entries()) {
        params[pair[0]] = pair[1];
      }

      const {okzs, okveds, ...tempStandart} = this.standard;

      if (this.codeChanged || this.nameForKindChanged) {
        await this.UPDATE_KIND({
          kind_id: this.kindId,
          code: params.kind_code,
          name: params.kind_name,
          purpose: this.goalForKind
        });
        await this.LOAD_KINDS()
      }

      await this[this.isExistStandard ? 'UPDATE_STANDARD' : 'CREATE_STANDARD']({
        ...tempStandart,
        ...params
      });

      if (!this.isExistStandard) {
        await this.LOAD_KINDS();
      }

      this.codeChanged = false
      this[editable] = false;
    },
    updateWorkFunctionItems() {
      this.LOAD_DICTIONARY_WORK_FUNCTION_ITEMS(this.activeWorkFunction.id)
    },
    async saveKindLifecycle(value) {
      await this.UPDATE_KIND({kind_id: this.kindId, lifecycle_id: value});
      await this.LOAD_KINDS()
    },
    dropChanges(category) {
      this.companyEditable = false;
    }
  },
  computed: {
    ...mapGetters('editor', ['GET_KIND_BY_ID', 'GET_OKVEDS_BY_ID', 'GET_OKZS_BY_ID']),
    ...mapState('common', ['dialogs', 'panels']),
    ...mapState('editor', ['activeStep', 'kinds', 'groupItemsBy', 'okzs', 'selectedAreas', 'standard', 'workFunctionItems', 'workFunctionsByStandard', 'lifecycles']),
    isExistStandard() {
      return this.standard?.id;
    },
    kindName() {
      return this.GET_KIND_BY_ID(this.kindId).name;
    },
    kindCode() {
      return this.GET_KIND_BY_ID(this.kindId).code;
    },
    responsible() {
      return this.standard.responsible;
    },
    organisations() {
      return this.standard.organisations;
    }
  },
  watch: {
    'panels.standard': async function (val, oldVal) {
      if (val === 0 && this.lifecycleIdChanged) {
        this.saveKindLifecycle(this.tempLifecycleId);
      } else if (oldVal === 0) {
        this.tempLifecycleId = this.lifecycleId
      }
    },
    'standard.name': function (val) {
      this.nameForStandard = val
    },
    'kindName': function (val) {
      this.nameForKind = val
    },
    'standard.register_number': function (val) {
      this.registerNumberForStandart = val
    },
    'standard.status_document': function (val) {
      this.statusForStandart = val
    },
    'standard.kind_goal': function (val) {
      this.goalForKind = val
    },
  },
  mounted() {
    this.nameForStandard = this.standard?.name
    this.nameForKind = this.kindName
    this.tempLifecycleId = this.lifecycleId
    this.registerNumberForStandart = this.standard?.register_number
    this.statusForStandart = this.standard?.status_document
    this.goalForKind = this.standard?.kind_goal ?? this.kindGoal
  }
}
</script>

<style scoped>
.justify-center {
  justify-content: left;
}
</style>